'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cyrillicLettersAndMarks = require('./cyrillicLettersAndMarks');

var _cyrillicLettersAndMarks2 = _interopRequireDefault(_cyrillicLettersAndMarks);

var _latinAccentChars = require('./latinAccentChars');

var _latinAccentChars2 = _interopRequireDefault(_latinAccentChars);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validUrlBalancedParens = require('./validUrlBalancedParens');

var _validUrlBalancedParens2 = _interopRequireDefault(_validUrlBalancedParens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Valid end-of-path chracters (so /foo. does not gobble the period).
// 1. Allow =&# for empty URL parameters and other URL-join artifacts
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validUrlPathEndingChars = (0, _regexSupplant2.default)(/[\+\-a-z#{cyrillicLettersAndMarks}0-9=_#\/#{latinAccentChars}]|(?:#{validUrlBalancedParens})/i, { cyrillicLettersAndMarks: _cyrillicLettersAndMarks2.default, latinAccentChars: _latinAccentChars2.default, validUrlBalancedParens: _validUrlBalancedParens2.default });

exports.default = validUrlPathEndingChars;
module.exports = exports['default'];